import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';
import { requiredWhenPresent } from '../../shared/propTypes';
import { PeriodPropTypes } from '../../shared/propTypes/period';
import { TaxRatePropTypes } from '../../shared/propTypes/taxRates';

const DeleteModal = ({
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isVisible,
  isRemovingInProgress,
  period,
}) => {
  const removeTaxRate = useCallback(() => {
    removeEntity({
      ...entityToRemove,
      periodName: period.name,
    }, { rowIndex });
  }, [removeEntity, entityToRemove, rowIndex, period]);

  return (
    <Modal
      className="delete-tax-rate-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Tax Rate"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeTaxRate}
      isVisible={isVisible}
      isSubmitting={isRemovingInProgress}

    >
      { entityToRemove
        ? (
          <div>
            Are you sure you want to delete: <br/><br/>
            Country Tax Type: {entityToRemove.countryTaxType}<br/>
            Country Code: {entityToRemove.countryCode}<br/>
            Description: {entityToRemove.description}<br/>
            Period: {period.name}<br/><br/>
          </div>
        )
        : null
      }
    </Modal>
  );
};

DeleteModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  period: PeriodPropTypes.isRequired,
  entityToRemove: requiredWhenPresent(['isVisible'], TaxRatePropTypes),
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
  isRemovingInProgress: PropTypes.bool.isRequired,
};

export default DeleteModal;
